'use client';
import { useState } from 'react';
import ZepidTubeVideos from '@/features/zepid-tube/components/ZepidtubeVideos';
import ZepidTubePlaylists from '@/features/zepid-tube/components/ZepidTubePlaylists';
import ZepidTubeShorts from '@/features/zepid-tube/components/ZepidTubeShorts';
import ZepidTubeHome from '@/features/zepid-tube/components/ZepidtubeHome';
import { useFetcherCSR } from '@/lib/useFetcherCSR';
import Preloader from '@/features/preloader/components/Preloader';

// Demo data
const demoSetting = {
  subtitle: 'Explore our content',
  title: 'Zepid Tube',
  description: 'Discover amazing videos, shorts and playlists',
};

export default function ZepidTubePage() {
  const [currentTab, setCurrentTab] = useState('Home');
  const tabs = ['Home', 'Videos', 'Shorts', 'Playlists'];

  const { data: videos, isLoading } = useFetcherCSR('/api/v2/kireitube-home');

  if (isLoading) return <Preloader />;
  return (
    <main className="main about">
      {/* <div className="page-header">
        <div className="container">
          <div
            style={{
              backgroundImage:
                'url("https://ecommerceapp.thetork.com/storage/all/App-Banner.png")',
              backgroundSize: 'cover',
              backgroundPosition: 'center center',
            }}
            className="d-flex flex-column align-items-center text-center padding-top padding-bottom rounded-3"
          >
            <h1 className="fw-semibold">{demoSetting?.title}</h1>
            <p>{demoSetting?.description}</p>
          </div>
        </div>
      </div> */}

      <div className="padding-bottom padding-top">
        <div className="container">
          <div className="section-header">
            <ul className="post-tabs">
              {tabs.map((tab) => (
                <li
                  key={tab}
                  onClick={() => setCurrentTab(tab)}
                  className={currentTab === tab ? 'active' : ''}
                >
                  {tab}
                </li>
              ))}
            </ul>
          </div>
        </div>

        {currentTab === 'Home' && (
          <ZepidTubeHome
            videos={videos?.videos?.data}
            playlists={videos?.playlists}
            shorts={videos?.shorts.data}
            updateValue={setCurrentTab}
          />
        )}
        {currentTab === 'Videos' && (
          <ZepidTubeVideos initialVideos={videos?.videos?.data} />
        )}
        {currentTab === 'Shorts' && (
          <ZepidTubeShorts initialShorts={videos?.shorts.data} />
        )}
        {currentTab === 'Playlists' && (
          <ZepidTubePlaylists initialPlaylists={videos?.playlists} />
        )}
      </div>
    </main>
  );
}
